import type { useCareProviderQuickListQuery$variables } from "@/modules/care-provider/simple-search/services/__generated__/useCareProviderQuickListQuery.graphql"
import { useChCareProvidersLazyQuery } from "@/modules/care-provider/simple-search/services/useCareProviderQuickListQuery"
import type { ApplicableBetterDocUsage } from "@/modules/patients/detail/better-doc/hooks/useApplicableBetterDocUsage"
import { usePreselectCareProviderOnceSelectionIsUnblocked } from "@/modules/patients/detail/progress-note/point-of-care/hooks/usePreselectCareProviderOnceSelectionIsUnblocked"

type CareProviderPreselectionOnceSelectionIsUnblockedProps = {
  careProviderQuickListQueryVariables: useCareProviderQuickListQuery$variables
  applicableBetterDocUsage: ApplicableBetterDocUsage
}

export const CareProviderPreselectionOnceSelectionIsUnblocked = ({
  careProviderQuickListQueryVariables,
  applicableBetterDocUsage,
}: CareProviderPreselectionOnceSelectionIsUnblockedProps) => {
  const { ch_careProviderQuickList } = useChCareProvidersLazyQuery(
    careProviderQuickListQueryVariables,
    "store-or-network",
  )

  usePreselectCareProviderOnceSelectionIsUnblocked({
    applicableBetterDocUsage,
    preselectedCareProviderId: ch_careProviderQuickList.preselectedCareProviderId ?? null,
  })

  return null
}
